
<template>
  <el-form-item :label="params.label" class="watsonDaterange">
    <el-date-picker
      class="w150"
      size="small"
      v-model="value"
      type="datetime"
      placeholder="选择日期时间"
      :default-time="params.defaultTime || '12:00:00'"
      @change="change">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { dateFormat } from '@/utils/tools'
export default {
  name: 'form-dataRange',
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      value: null
    }
  },
  created() {},
  methods: {
    reset() {
      if (this.params.dValue) {
        this.value = this.params.dValue ? new Date(this.params.dValue) : new Date()
      } else {
        this.value = undefined
      }
    },
    getValue() {
      if (this.value) {
        return {
          [this.params.key]: dateFormat(this.value, 'yyyy-MM-dd hh:mm:ss')
        }
      }
      return undefined
    },
    change() {
      const cp = JSON.parse(JSON.stringify(this.params))
      cp.value = this.value
      this.$emit('csi', cp)
    }
  }
}
</script>

<style lang="less">
@import "../miBicycle.less";
</style>
